import { CalcAkte } from '@dpa/common/dist'
import { useSyncAkteWithBCMutation } from './mutations/useSyncAkteWithBCMutation'
import { useCallback, useState } from 'react'
import { SyncError } from '@dpa/server/integations/bc/bcSyncers'
import { trpc } from '../../../App'

const orderNumberFields: Array<keyof CalcAkte> = [
  'PDB_Auftragsnummer',
  'PDB_Auftragsnummer_PC',
  'PDB_Auftragsnummer_Nachtrag0',
  'PDB_Auftragsnummer_Nachtrag1',
  'PDB_Auftragsnummer_Nachtrag2',
  'PDB_Auftragsnummer_Nachtrag3',
  'PDB_Auftragsnummer_Nachtrag4',
  'PDB_Auftragsnummer_Planung',
  'PDB_Servicevertrag_Angebot',
  'PDB_Auftragsnummer_laufende_Kosten',
]

export function useSyncAkteWithBC(akte: Partial<CalcAkte> | undefined) {
  const syncBCMutation = useSyncAkteWithBCMutation()
  const trpcCtx = trpc.useUtils()
  const hasOrderNumber = orderNumberFields.some((fieldName) => {
    const value = akte?.[fieldName]
    return typeof value === 'string' && value !== ''
  })
  const canSyncBC = akte?.id != undefined && hasOrderNumber
  const [errors, setErrors] = useState<Array<SyncError>>([])
  const syncBCFunction = useCallback(() => {
    if (akte != undefined && canSyncBC) {
      syncBCMutation.mutate(
        {
          id: akte.id!,
        },
        {
          onSuccess: (result) => {
            trpcCtx.akte.salesLines.invalidate()
            trpcCtx.akte.invoices.invalidate({ id: akte.id! })
            trpcCtx.akte.serviceContractLines.invalidate({ id: akte.id! })
            if (result.errors.length > 0) {
              console.log('errors', result.errors)
              setErrors(result.errors)
            } else {
              if (errors.length > 0) {
                setErrors([])
              }
            }
          },
        }
      )
      return true
    }
    return undefined
  }, [
    akte,
    canSyncBC,
    syncBCMutation,
    trpcCtx.akte.salesLines,
    trpcCtx.akte.invoices,
    trpcCtx.akte.serviceContractLines,
    errors.length,
  ])

  return { canSyncBC, syncBCFunction, syncBCMutation, errors }
}
